import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcClose32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m7.618 6.194 8.382 8.382 8.293-8.276a.957.957 0 0 1 .704-.299c.55 0 1.003.42 1.003 1.003 0 .26-.065.453-.29.68l-8.287 8.316 8.285 8.317a.987.987 0 0 1 .291.68.988.988 0 0 1 -1.002 1.003c-.26 0-.453-.065-.68-.29l-8.317-8.287-8.293 8.277a.957.957 0 0 1 -.704.299.988.988 0 0 1 -1.003-1.002c0-.26.065-.453.29-.68l8.287-8.317-8.286-8.317a.988.988 0 0 1 -.291-.68c0-.55.42-1.003 1.003-1.003.194 0 .42.065.615.194z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcClose32;
